export default {"src":"/_next/static/media/placeholder.2797160d.svg","height":376,"width":282,"blurWidth":0,"blurHeight":0};